import React, { useState } from 'react';
import moment from 'moment';
import DataGrid from '../grid';
import { IconButton, Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { Link } from 'react-router-dom';
import Pagination from '../grid/Pagination';
import MuiDialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { v2UIRoutePath } from '../../../common/commons';
import { CheckBoxOutlineBlank} from '@mui/icons-material';

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: '16px 16px 0 16px',
    },
    iconsContainter: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    closeButton: {

        color: theme.palette.grey[500],
    },
    minimize:{
        width: '20px',
        height: '20px',
      
    }
});

function ReportPopup(props) {
    // State used to handle the Active page
    const [currentPage, setCurrentPage] = useState(1);

    // serverPagination: { currentPage, pageSize, totalCount, totalPages, onPageChange } - modelData holds only the current page
    const { enablePagination = true, columns, customRowHeight = 30, serverPagination } = props;
    /**
     * This Method updates the current active page to load on to the grid
     * @param {Active Page to load} page 
     */
    const handlePageChange = (page) => {
        // Updating the Active Page to load
        setCurrentPage(page);
    }
    // Limiting the page Size on the grid to 75
    const pageSize = 75;
    // Calculating the Grid Start Index based on the loaded page
    const startPageIndex = ((currentPage - 1) * pageSize);
    // Loading only the current page data into the toloadPage Variable
    const toLoadPage = serverPagination ? props.modelData : props.modelData.slice(startPageIndex, startPageIndex + pageSize);
    // Formating the Data based on the columns for tooltip on the Time columns
    const rows = toLoadPage?.map((_model) => {
        const { dsar_id, ticket_type, created_date, requestor } = _model;
        return {
            id: dsar_id,
            dsrId: dsar_id,
            requesttype: ticket_type,
            requestor,
            createdDateandTimeLocal: created_date ? moment(created_date).local().format('MMM Do, YYYY HH:mm:ss [(local)]') : '--',
            createdDateandTime: created_date ? moment(created_date).format("MM-DD-YYYY") : '--',
            createdDateandTimeUTC: created_date ? moment(created_date).utc().format("MMM Do, YYYY HH:mm:ss (UTC)") : '--',
            ..._model
        }
    })
    return (
        <>
            <DataGrid
                customRowHeight={customRowHeight}
                customHeight={"calc(100% - 40px)"}
                enabledarktheme={true}
                columns={columns || [{
                    name: "Request ID",
                    mapping: "dsrId",
                    renderCell: (params) => (
                        <Link to={`${v2UIRoutePath}requestdetails/` + params.row["dsrId"]}>
                            {params.row["dsrId"]}
                        </Link>
                    )
                }, {
                    name: "Request Type",
                    mapping: "requesttype",
                    width: 150,
                }, {
                    name: "Requestor",
                    mapping: "requestor",
                    width: 95,
                }, {
                    name: "Created Date",
                    mapping: "createdDateandTime",
                    width: 200,
                    renderCell: (params) => (
                        <Tooltip title={params.row["createdDateandTimeLocal"]}>
                            <span>
                                {params.row["createdDateandTimeUTC"]}
                            </span>
                        </Tooltip>
                    ),
                }]}
                // customHeight={350}
                autoHeight={false}
                rows={rows}
            />
            {enablePagination && serverPagination && (<Pagination
                currentPage={serverPagination.currentPage}
                pageCount={serverPagination.pageSize}
                totalResults={serverPagination.totalCount}
                totalPages={serverPagination.totalPages}
                pageChange={serverPagination.onPageChange}
            />)}
            {enablePagination && !serverPagination && (<Pagination
                currentPage={currentPage}
                pageCount={75}
                totalResults={props.modelData?.length}
                pageChange={handlePageChange}
            />)}
        </>
    );
}

export const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, dialogState, onMinimize, onMaximize,isForm, ...other } = props;
    return (
        <MuiDialogTitle className={classes.root} {...other}>
            <div>{children}</div>
            <div className={classes.iconsContainter}
            >
                {dialogState === 'maximized' ? (
                    <IconButton data-testid={"dialog-minimize-button"} aria-label="minimize" className={classes.closeButton} onClick={onMinimize}>
                         <img alt="" className={classes.minimize} src={isForm ? "/white-minimize-icon.svg":"/minimize-icon.svg"} width="120"></img>
                    </IconButton>
                ): (
                    <IconButton data-testid={"dialog-maximize-button"} aria-label="maximize" className={classes.closeButton} onClick={onMaximize}>
                        <CheckBoxOutlineBlank />
                    </IconButton>
                )}
                {onClose ? (
                    <IconButton data-testid={"dialog-close-button"} aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </div>
        </MuiDialogTitle>
    );
});

export default ReportPopup;
